export const FLAG_GETTING_AGENCY_GROUPS = 'FLAG_GETTING_AGENCY_GROUPS';
export const GET_AGENCY_GROUPS = 'GET_AGENCY_GROUPS';
export const CLEAR_AGENCY_GROUPS = 'CLEAR_AGENCY_GROUPS';
export const FLAG_AGENCY_GROUP_ACTIVITY = 'FLAG_AGENCY_GROUP_ACTIVITY';
export const GET_AGENCY_GROUP = 'GET_AGENCY_GROUP';
export const CLEAR_AGENCY_GROUP = 'CLEAR_AGENCY_GROUP';
